
import { Component, Vue, Prop } from 'vue-property-decorator';
import { DeviceInfo } from '@/types/device-info';
import { Subscription } from '@/types/subscriptions';
import { SubscriptionStatus } from '@/constants/subscription_status';
import * as dlg from '@/modules/dlg';
import PauseSubscriptionConfirmationModal from '@/components/devices/popups/PauseSubscriptionConfirmationModal.vue';
import { getCurrencySymbol } from '@/utils/currency';

@Component({
    components: { PauseSubscriptionConfirmationModal },
})
export default class DeviceCurrentSubscriptionMenu extends Vue {
    @Prop({ required: true })
    subscriptionItem!: Subscription;

    @Prop({ required: true })
    device!: DeviceInfo;

    @Prop({ required: true })
    onPause!: (subscription: Subscription, resumeDate: string) => void;

    @Prop({ required: true })
    onResume!: (subscription: Subscription) => void;

    @Prop({ required: true })
    onCancel!: (subscription: Subscription) => void;

    protected SubscriptionStatus = SubscriptionStatus;
    protected pauseDialog = false;
    protected getCurrencySymbol = getCurrencySymbol;

    isMenu() {
        const {
            // status,
            cancel_at_period_end,
        } = this.subscriptionItem?.sourceData;
        // return cancel_at_period_end == true || status === SubscriptionStatus.Trialing ? false : true;
        return cancel_at_period_end == true ? false : true;
    }

    isPause() {
        const { status, pause_collection, cancel_at_period_end, schedule } = this.subscriptionItem?.sourceData;
        return status !== SubscriptionStatus.Trialing && pause_collection == null && cancel_at_period_end == false && !schedule;
    }

    isResume() {
        const { pause_collection, cancel_at_period_end, schedule } = this.subscriptionItem?.sourceData;
        return ( pause_collection && Object.keys(pause_collection).length > 0 && !schedule) || cancel_at_period_end == true && !schedule;
    }

    isCancel() {
        const { cancel_at_period_end } = this.subscriptionItem?.sourceData;
        return cancel_at_period_end == false && !this.isResume();
    }

    async handlePause(subscriptionItem: Subscription) {
        const {
            pauseDeductionActive,
            pauseDeductionAmount,
            pauseDeductionDays,
        } = subscriptionItem?.sourceData.metadata;

        const confirmMsg =
            pauseDeductionActive == 'true'
                ? `Monthly fee of  ${getCurrencySymbol(
                      subscriptionItem?.terms?.currency ? subscriptionItem?.terms.currency : 'USD',
                  )}${parseFloat(pauseDeductionAmount ?? 0).toFixed(2)} will be deducted if plan
                            is paused more than ${pauseDeductionDays ?? 0} days.`
                : `Are you sure you want to pause the subscription.`;
        const confirmed = await dlg.confirm(confirmMsg, 'Pause subscription');
        if (!confirmed) return;
        this.pauseDialog = true;
    }

    async handleCancel(subscriptionItem: Subscription) {
        const confirmed = await dlg.confirm('Are you sure you want to cancel the subscription.', 'Cancel subscription');
        if (!confirmed) return;
        this.onCancel(subscriptionItem);
    }

    async handleResume(subscriptionItem: Subscription) {
        const confirmed = await dlg.confirm('Are you sure you want to resume the subscription.', 'Resume subscription');
        if (!confirmed) return;
        this.onResume(subscriptionItem);
    }
}
